// extracted by mini-css-extract-plugin
export default {"root":"gAJTXyr","successIcon":"i0aYH7e","errorIcon":"a43vFd3","fetchingSpinner":"+BGjApo"};